export const renderEmail = () => {
  const email = 'kundservice@karnkraft.se';
  const emailElement = document.getElementsByClassName("protect");

  if (emailElement) {
    emailElement[0].innerHTML = `<a href="mailto:${email}">${email}</a>`;
  }
}
